import React from 'react'

import GovActionContainer from './container'
import GovActionWrapper from './views/wrapper'
import GovActionToggle from './views/toggle'
import GovActionComplete from './views/complete'

// eslint-disable-next-line react/display-name
const RecordListActions = ({ options, labelText = 'Register as...', defaultState }) => (
  <GovActionContainer
    options={options}
    defaultState={defaultState}
    labelText={labelText}
    render={({
      open,
      toggle,
      defaultOption,
      currentOption,
      actionForm,
      onChange,
      options,
      handleSuccess,
      isCompleted,
      completedMessage,
      onComplete,
      resetForm,
      labelText,
    }) => (
        <GovActionWrapper
          open={open}
          render={() => (
            <GovActionToggle
              name="topic"
              open={open}
              toggle={
                isCompleted
                  ? defaultOption.onComplete || currentOption.onComplete
                    ? () => {
                      resetForm()
                      const onCompleteToUse = defaultOption.onComplete
                        ? defaultOption.onComplete
                        : currentOption.onComplete

                      onCompleteToUse()
                    }
                    : onComplete
                  : toggle
              }
              icon={defaultOption.icon}
              label={defaultOption.label || labelText}
              options={options}
              onChange={onChange}
              formSuccess={isCompleted}
            />
          )}>
          {isCompleted ? (
            <GovActionComplete
              onClick={
                defaultOption.onComplete || currentOption.onComplete
                  ? () => {
                    resetForm()
                    const onCompleteToUse = defaultOption.onComplete
                      ? defaultOption.onComplete
                      : currentOption.onComplete

                    onCompleteToUse()
                  }
                  : onComplete
              }>
              {completedMessage}
            </GovActionComplete>
          ) : (actionForm ?
            React.createElement(actionForm, {
              currentOption,
              onChange,
              handleSuccess,
            })
            : null
            )}
        </GovActionWrapper>
      )}
  />
)

export default RecordListActions



// WEBPACK FOOTER //
// ./src/ui/gov-actions/record-list-actions.jsx